<template>
    <div>
        <div id="BLAST-description">
            <a>BLAST</a>
        </div>
        <hr style="color: #2E8B57">
        <br>
        <iframe ref="iframe" id="bdIframe" :src="bdTokenUrl" frameborder="0" scrolling="yes" ></iframe>
    </div>
</template>

<script>
    export default {
        name: "BLAST",
        data() {
            return {
                bdTokenUrl: 'http://39.100.233.196:81/'
            }
        },
        created() {
            this.getUrl();
            this.$nextTick(()=>{
                this.getCode();
            });
        },
        mounted(){
            /**
             * iframe-宽高自适应显示
             */
            const oIframe = document.getElementById('bdIframe');
            // const deviceWidth = document.documentElement.clientWidth;
            const deviceHeight = document.documentElement.clientHeight;
            oIframe.style.width = 1155 + 'px'; //数字是页面布局宽度差值
            oIframe.style.height = (Number(deviceHeight)-120) + 'px'; //数字是页面布局高度差
        },
        methods: {
            /**
             * 获取-外部接口信息
             */
            getUrl() {
                let that = this
                let bdUrl = {queryurl: this.$paths.bdpath+'/locate'};
                this.$api.getBdToken(bdUrl,function(res) {
                    that.bdTokenUrl = res.data.data;
                })
            },
        }
    }
</script>

<style>
    #bdIframe {
        margin: 10px 22px 30px 22px;
        overflow: scroll;
    }

    #BLAST-description {
        width: 1000px;
        height: 50px;
        margin: 15px auto;
        text-align: center;
        font-size: 25px;
        color: #407338;
        font-weight: bold;
    }

</style>